const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
const API_URL =
  process.env.REACT_APP_API_URL || API_ENDPOINT?.replace(/\/v1\/?$/, "");

const buildApiUrl = (path: string) => {
  if (!path) return "";
  if (path.startsWith("http") || path.startsWith("blob:") || path.startsWith("data:")) {
    return path;
  }

  const baseUrl = API_URL || "";
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;

  return `${baseUrl}${normalizedPath}`;
};

export const getImageUrl = (path: string) => {
  if (!path) return "";

  if (path.startsWith("protected://")) {
    return path.replace("protected://", "");
  }

  return buildApiUrl(path);
};

// export const getImageUrl = (path: string) => {
//   if (!path) return "";
//   return `${API_URL}/${path}`;
// };

export const getPostUrl = (path: string) => {
  if (!path || path.startsWith("http") || path.startsWith("blob:") || path.startsWith("data:")) {
    return path;
  }

  if (path.startsWith("/v1/media/") || path.startsWith("/v1/uploads/")) {
    return buildApiUrl(path);
  }

  return buildApiUrl(`/v1/media/${path.replace(/^\/+/, "")}`);
};

// export const getPostUrl = (path: string) => {
//   return `${API_URL}/uploads/posts/${path}`;
// };
